import Modal from "react-modal";
import React, { useState } from "react";
import * as S from "./styles";
import Input from "../../Input";
import Select from "../../Select";
import { getReports, getReportsToExcel } from "services/ReportServices";
import { fireAlert, fireToast } from "services/sweetAlertConfig";
import { IPoliceman } from "interfaces/Policeman";
import { OccurrenceToggleButton } from "../../OccurrenceToggleButton";
import { ReactComponent as CloseIcon } from "assets/close-small.svg";
import { parseDate } from "utils/parseDate";
import { Flex } from "monk_ui";
import { InputMap } from "components/InputMap";
import { useDataList } from "hooks/useDataList";

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

Modal.setAppElement("#root");

export default function ExportMaintenanceModal({
  modalIsOpen,
  setIsOpen,
}: ModalProps) {
  function closeModal() {
    setIsOpen(false);
  }
  const [start, setStart] = useState<Date>();
  const [lat, setLat] = useState<number>();
  const [lng, setLng] = useState<number>();
  const [range, setRange] = useState<number>();
  const [finish, setFinish] = useState<Date>();
  const [policeman, setPoliceman] = useState<string>();
  const [requesting, setRequesting] = useState<boolean>(false);
  const [patrimonialType, setPatrimonialType] = useState<boolean | undefined>();
  const [isPdf, setIsPdf] = useState<boolean>(true);

  const { data } = useDataList<IPoliceman>({
    queryKey: 'listAllPolicemen',
    route: 'policemen',
    filter: {
      relations: { user: true },
      notPage: true,
    }
  });

  function requestReport() {
    setRequesting(true);
    if (isPdf)
      return getReports({
        start,
        finish,
        policeman,
        type: patrimonialType,
        lat,
        lng,
        range,
      })
        .then(async (res) => {
          const file = new Blob([res.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          setRequesting(false);

          fireToast("Relatório gerado com sucesso");
        })
        .catch((err) => {
          if (err.response.status === 404) {
            fireAlert(
              "error",
              "Nenhum relatório encontrado",
              "Nenhum relatório encontrado com os parametros"
            );
          } else {
            fireAlert("error", "Não foi possível gerar o relatório");
          }
          setRequesting(false);
        });

    getReportsToExcel({
      start,
      finish,
      policeman,
      type: patrimonialType,
      lat,
      lng,
      range,
    })
      .then((res) => {
        const fileURL = URL.createObjectURL(res.data);
        const link = document.createElement("a");

        link.href = fileURL;
        link.setAttribute("download", `reports.xlsx`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(fileURL);
        setRequesting(false);
        fireToast("arquivo gerado com sucesso");
      })
      .catch((err) => {
        fireAlert("error", "Aconteceu um erro");
        console.log({ err });
        setRequesting(false);
      });
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentElement={(props, children) => (
        <S.ActiveContent {...props}>{children}</S.ActiveContent>
      )}
      overlayElement={(props, contentElement) => (
        <S.ActiveOverlay {...props}>{contentElement}</S.ActiveOverlay>
      )}
    >
      <S.Content>
        <Flex alignItems="center" justifyContent="flex-end" height="1.875rem">
          <CloseIcon style={{ cursor: "pointer" }} onClick={closeModal} />
        </Flex>

        <h2>Exportar relatório</h2>
        <p>
          Escolha a data de começo e fim para gerar o relatório durante o
          período. (Não escolher datas irá gerar um relatório dos últimos 30
          dias.)
        </p>

        <S.Row>
          <S.Column>
            <Select
              containerClassName="select-container"
              id="policeman"
              name="policeman"
              onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                setPoliceman(event.target.value);
              }}
              label="Adicionar Pronta resposta - (Opcional)"
              required={false}
              placeholder="Selecione uma opção"
            >
              <option value="Padrão">Selecione um Pronta Resposta</option>
              {data?.items?.map((policeman) => (
                <option key={policeman.id} value={policeman.id}>
                  {policeman.user?.name}
                </option>
              ))}
            </Select>
            <Input
              id="start"
              name="start"
              required
              type="Date"
              label="Data Inicial"
              onChange={(e) => {
                parseDate(setStart, e.target.value);
              }}
            />
            <Input
              id="finish"
              name="finish"
              required
              type="Date"
              label="Data Final"
              onChange={(e) => {
                parseDate(setFinish, e.target.value);
              }}
            />
            <OccurrenceToggleButton
              isEstablishment={isPdf}
              label="Selecione o tipo de arquivo"
              leftLabel="Pdf"
              rightLabel="Excel"
              leftClick={() => {
                setIsPdf(true);
              }}
              response
              rightClick={() => {
                setIsPdf(false);
              }}
            />
          </S.Column>
          <S.Column>
            <OccurrenceToggleButton
              isEstablishment={patrimonialType}
              label="Selecione um filtro para ocorrência - (Opcional)"
              leftLabel="Residencial"
              rightLabel="Veículo"
              leftClick={() => {
                if (patrimonialType === true) {
                  setPatrimonialType(undefined);
                } else {
                  setPatrimonialType(true);
                }
              }}
              response
              rightClick={() => {
                if (patrimonialType === false) {
                  setPatrimonialType(undefined);
                } else {
                  setPatrimonialType(false);
                }
              }}
            />

            <InputMap
              label="Endereço - (Opcional)"
              onCoordsChange={(coords) => {
                setLat(coords.lat);
                setLng(coords.lng);
              }}
            />

            <Input
              id="KM"
              name="KM"
              required
              type="number"
              label="KM de distancia do endereço  - (Opcional)"
              onChange={(e) => {
                setRange(Number(e.target.value));
              }}
            />
          </S.Column>
        </S.Row>
        <S.ActiveConfirmButton
          disabled={requesting}
          onClick={() => requestReport()}
          type="button"
        >
          Gerar relatório
        </S.ActiveConfirmButton>
      </S.Content>
    </Modal>
  );
}
